import React, { Component } from "react";
import classes from "./SideBarAccordion.module.scss";

export default class SideBarAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }

  render() {
    return (
      <div
        className={classes.AccordionWrapper}
        onClick={() => this.setState({ isActive: !this.state.isActive })}
      >
        {this.state.isActive ? (
          <div className={classes.AccordionTitleAdAlt}>{this.props.title}</div>
        ) : (
          <div className={classes.AccordionTitleAd}>{this.props.title}</div>
        )}

        {this.state.isActive && (
          <ul className={`${classes.SubCats} SubCats`}>{this.props.data2}</ul>
        )}
      </div>
    );
  }
}
